/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseCancelReqVo
 */
export interface PurchaseCancelReqVo {
    /**
     * 采购取消记录id
     * @type {number}
     * @memberof PurchaseCancelReqVo
     */
    id?: number;
    /**
     * 订单id
     * @type {number}
     * @memberof PurchaseCancelReqVo
     */
    orderId?: number;
    /**
     * 采购取消商品id数组
     * @type {Array<number>}
     * @memberof PurchaseCancelReqVo
     */
    goodsIds?: Array<number>;
    /**
     * 申请采购取消理由
     * @type {number}
     * @memberof PurchaseCancelReqVo
     */
    cancelReason?: number;
    /**
     * 申请采购取消详细理由
     * @type {string}
     * @memberof PurchaseCancelReqVo
     */
    cancelReasonDetail?: string;
    /**
     * 是否发送短信通知 0 不发送  1 发送
     * @type {number}
     * @memberof PurchaseCancelReqVo
     */
    sendSms?: number;
}

/**
 * Check if a given object implements the PurchaseCancelReqVo interface.
 */
export function instanceOfPurchaseCancelReqVo(value: object): value is PurchaseCancelReqVo {
    return true;
}

export function PurchaseCancelReqVoFromJSON(json: any): PurchaseCancelReqVo {
    return PurchaseCancelReqVoFromJSONTyped(json, false);
}

export function PurchaseCancelReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCancelReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'goodsIds': json['goodsIds'] == null ? undefined : json['goodsIds'],
        'cancelReason': json['cancelReason'] == null ? undefined : json['cancelReason'],
        'cancelReasonDetail': json['cancelReasonDetail'] == null ? undefined : json['cancelReasonDetail'],
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
    };
}

export function PurchaseCancelReqVoToJSON(json: any): PurchaseCancelReqVo {
    return PurchaseCancelReqVoToJSONTyped(json, false);
}

export function PurchaseCancelReqVoToJSONTyped(value?: PurchaseCancelReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderId': value['orderId'],
        'goodsIds': value['goodsIds'],
        'cancelReason': value['cancelReason'],
        'cancelReasonDetail': value['cancelReasonDetail'],
        'sendSms': value['sendSms'],
    };
}

